export default "__VITE_ASSET__DWn7Qplz__"